import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError, fmtDate } from "@/lib/api";

const STYLE = { started: "bg-amber-100 text-amber-800", paid_reported: "bg-sky-100 text-sky-800", confirmed: "bg-emerald-100 text-emerald-800", cancelled: "bg-slate-100 text-slate-500" };

export function PaymentsPanel() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/payments").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const update = (id, status) => api.patch(`/admin/payments/${id}`, { status }).then(() => { toast.success(`Marked ${status}`); load(); }).catch((e) => toast.error(formatApiError(e)));
  if (!rows) return null;
  return (
    <div className="flex flex-col gap-4" data-testid="payments-panel">
      <p className="text-sm text-slate-600">People who opened PayPal checkout. Check the payment in your PayPal account, then mark it confirmed.</p>
      <div className="bg-white rounded-2xl border border-[#0B2A4A]/10 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-[#FAF6EE] text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Person</th><th className="px-4 py-3">Add-ons</th><th className="px-4 py-3">Started</th><th className="px-4 py-3">Status</th><th className="px-4 py-3" /></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-slate-500">No payments yet.</td></tr>}
            {rows.map((p) => (
              <tr key={p.id} className="border-t border-[#0B2A4A]/5" data-testid="payment-row">
                <td className="px-4 py-3"><p className="font-semibold text-[#0B2A4A]">{p.name}</p><p className="text-xs text-slate-500">{p.email}</p><p className="text-xs text-[#147C88]" data-testid="payment-package">{p.course} · ${p.amount}</p></td>
                <td className="px-4 py-3 text-xs text-slate-600">{[...(p.add_ons || []), p.add_ons_other].filter(Boolean).join(", ") || "—"}</td>
                <td className="px-4 py-3 text-xs text-slate-500 font-mono-ui">{fmtDate(p.created_at)}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${STYLE[p.status]}`} data-testid="payment-status">{p.status === "paid_reported" ? "paid — check PayPal" : p.status}</span></td>
                <td className="px-4 py-3 text-right whitespace-nowrap">
                  {p.status !== "confirmed" && <button onClick={() => update(p.id, "confirmed")} className="rounded-lg bg-emerald-600 text-white px-3 py-1.5 text-xs font-semibold mr-2" data-testid="payment-confirm-btn">Confirm paid</button>}
                  {p.status === "started" && <button onClick={() => update(p.id, "cancelled")} className="rounded-lg border border-[#0B2A4A]/20 px-3 py-1.5 text-xs font-semibold" data-testid="payment-cancel-btn">Not paid</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
